import './form-group-messages.less';
import * as StringUtils from '../../../utils/string-utils';
import { compileTemplateComponentModule } from '../../compile-template/compile-template';

const FORM_GROUP_MESSAGES = [];

function addFormGroupMessage(key, message) {
  FORM_GROUP_MESSAGES.push({
    key,
    message,
  });
}

export const formGroupMessagesComponentModule = angular
  .module('Q.components.forms.form-group-messages', [
    compileTemplateComponentModule,
  ])

  .factory('FORM_GROUP_MESSAGES', function () {
    FORM_GROUP_MESSAGES.add = addFormGroupMessage;
    addFormGroupMessage(
      'required',
      ($input, formGroupField) => `Please provide ${formGroupField.name}.`,
    );
    addFormGroupMessage('match', `This password doesn't match the first one.`);
    addFormGroupMessage('minLength', ($input, formGroupField) => {
      if (formGroupField.minAndMaxLength) {
        return `${formGroupField.nameCapitalized} must be between ${formGroupField.minlength} and ${formGroupField.maxlength} characters long.`;
      } else if (formGroupField.minlength) {
        return `Please enter at least ${formGroupField.minlength} character${formGroupField.minlength === 1 ? '' : 's'}.`;
      } else {
        return `${formGroupField.nameCapitalized} is too short.`;
      }
    });
    addFormGroupMessage('maxLength', ($input, formGroupField) => {
      if (formGroupField.minAndMaxLength) {
        return `${formGroupField.nameCapitalized} must be between ${formGroupField.minlength} and ${formGroupField.maxlength} characters long.`;
      } else if (formGroupField.maxlength) {
        return `Please enter no more than ${formGroupField.maxlength} character${formGroupField.maxlength === 1 ? '' : 's'}.`;
      } else {
        return `${formGroupField.nameCapitalized} is too long.`;
      }
    });
    addFormGroupMessage('min', ($input, formGroupField) => {
      if (formGroupField.minAndMax) {
        return `${formGroupField.nameCapitalized} must be between ${formGroupField.min} and ${formGroupField.max} (inclusive).`;
      } else if (formGroupField.min) {
        return `${formGroupField.nameCapitalized} must be ${formGroupField.min} or greater.`;
      } else {
        return `${formGroupField.nameCapitalized} is too small.`;
      }
    });
    addFormGroupMessage('max', ($input, formGroupField) => {
      if (formGroupField.minAndMax) {
        return `${formGroupField.nameCapitalized} must be between ${formGroupField.min} and ${formGroupField.max} (inclusive).`;
      } else if (formGroupField.max) {
        return `${formGroupField.nameCapitalized} must be ${formGroupField.max} or smaller.`;
      } else {
        return `${formGroupField.nameCapitalized} is too big.`;
      }
    });
    addFormGroupMessage('minTags', ($input, formGroupField) => {
      if (formGroupField.minAndMaxTags) {
        return `${formGroupField.nameCapitalized} must have between ${formGroupField.minTags} and ${formGroupField.maxTags} items (inclusive).`;
      } else {
        return `${formGroupField.nameCapitalized} must have at least ${formGroupField.minTags} item${formGroupField.minTags === 1 ? '' : 's'}.`;
      }
    });
    addFormGroupMessage('maxTags', ($input, formGroupField) => {
      if (formGroupField.minAndMaxTags) {
        return `${formGroupField.nameCapitalized} must have between ${formGroupField.minTags} and ${formGroupField.maxTags} items (inclusive).`;
      } else {
        return `${formGroupField.nameCapitalized} must have no more than ${formGroupField.maxTags} item${formGroupField.maxTags === 1 ? '' : 's'}.`;
      }
    });
    addFormGroupMessage('url', 'Please provide a valid website URL.');
    addFormGroupMessage('email', 'Please provide a valid email address.');
    addFormGroupMessage('date', 'Please provide a valid date.');
    addFormGroupMessage('number', 'Please provide a valid number.');
    addFormGroupMessage('loginIncorrect', 'Incorrect password or username.');
    addFormGroupMessage('accountLocked', 'This account is no longer active.');

    return FORM_GROUP_MESSAGES;
  })

  .directive(
    'formGroupMessages',
    function ($animate, $timeout, FORM_GROUP_MESSAGES) {
      const SHOULD_SHOW_CLASS = 'msg-shouldshow';
      const SHOULD_HIDE_CLASS = 'msg-shouldhide';

      return {
        restrict: 'E',
        require: ['^^form', '^^formGroup'],
        scope: true,
        compile: function (tElement) {
          const customMessages = tElement.html().trim();
          tElement.html(
            '<compile-template src="messageContent"></compile-template>',
          );

          return function postLink(
            scope,
            elem,
            attrs,
            [ngFormCtrl, formGroupCtrl],
          ) {
            elem.addClass('help-block');

            formGroupCtrl.configureMessages = ($inputs) => {
              const input = $inputs && $inputs[0];
              const $input = (scope.$input = input && angular.element(input));
              let formGroupCtrlAttrs = formGroupCtrl.attrs || {};

              if (!$input) return;

              // --- configuring field properties ---

              const min = $input.attr('min');
              const max = $input.attr('max');
              const minLength = $input.attr('minlength');
              const ngMinLength = $input.attr('ng-minlength');
              const maxLength = $input.attr('maxlength');
              const ngMaxLength = $input.attr('ng-maxlength');
              const minTags = $input.attr('min-tags');
              const maxTags = $input.attr('max-tags');

              const formGroupField =
                (formGroupCtrl.formGroupField =
                scope.formGroupField =
                  {
                    name:
                      formGroupCtrlAttrs.fieldName ||
                      formGroupCtrlAttrs.label ||
                      'a value',
                    nameCapitalized:
                      formGroupCtrlAttrs.fieldNameCapitalized ||
                      StringUtils.ucFirst(
                        formGroupCtrlAttrs.fieldName ||
                          formGroupCtrlAttrs.label ||
                          'the value',
                      ),
                    min: min,
                    max: max,
                    minAndMax: min && max,
                    minlength:
                      minLength || (ngMinLength && scope.$eval(ngMinLength)),
                    maxlength:
                      maxLength || (ngMaxLength && scope.$eval(ngMaxLength)),
                    minTags: minTags && scope.$eval(minTags),
                    maxTags: maxTags && scope.$eval(maxTags),
                  });
              formGroupField.minAndMaxLength =
                formGroupField.minlength && formGroupField.maxlength;
              formGroupField.minAndMaxTags =
                formGroupField.minTags && formGroupField.maxTags;

              const getFormField = () => ngFormCtrl[$input.attr('name')];
              const getFormFieldErrors = () => {
                let field = getFormField();
                return (field && field.$error) || {};
              };

              // --- setting the message ---

              let lastErrorClass = '';

              function updateMessage() {
                elem.removeClass(lastErrorClass);
                let hadError = false;
                const errors = getFormFieldErrors();
                if (Object.keys(errors).length) {
                  let msgs = FORM_GROUP_MESSAGES;
                  if (customMessages) {
                    msgs = [];
                    angular.forEach(
                      scope.$eval(customMessages),
                      (message, key) => {
                        msgs.push({ key, message });
                      },
                    );
                    msgs.push(...FORM_GROUP_MESSAGES);
                  }
                  scope.messageContent = '';
                  hadError = msgs.some(({ key, message }) => {
                    if (errors[key]) {
                      lastErrorClass = key;
                      elem.addClass(lastErrorClass);
                      scope.messageContent = angular.isFunction(message)
                        ? message($input, formGroupField)
                        : message;
                      return true;
                    }
                  });
                }
                elem.toggleClass('ng-active', hadError);
                elem.toggleClass('ng-inactive', !hadError);
              }

              scope.$watch(
                () => Object.keys(getFormFieldErrors()).join(),
                updateMessage,
              );

              // --- hiding if the form wasn't submitted ---

              elem.addClass(SHOULD_HIDE_CLASS);
              scope.$watch(
                () => {
                  let field = getFormField();
                  // leftoverText is because tagsInput is marking the field as pristine if we error on the first item
                  return (
                    (ngFormCtrl && isFormSubmitted(ngFormCtrl)) ||
                    (field &&
                      (!field.$pristine || field.$error.leftoverText) &&
                      field.$touched)
                  );
                },
                (shouldShow) => {
                  $animate.setClass(
                    elem,
                    shouldShow ? SHOULD_SHOW_CLASS : SHOULD_HIDE_CLASS,
                    shouldShow ? SHOULD_HIDE_CLASS : SHOULD_SHOW_CLASS,
                  );
                },
              );
            };
          };
        },
      };
    },
  );

function isFormSubmitted(form) {
  /* eslint-disable angular/no-private-call */
  while (!form.$submitted && form.$$parentForm && form.$$parentForm.$name) {
    form = form.$$parentForm;
  }
  /* eslint-enable */
  return form.$submitted;
}
